import StyleConfTemplate from './StyleConfTemplate';
import WRadio from "../../../../../lib/builtin/components/Radio/index";
import StylePanelMixin from '../utils/StylePanelMixin';
const __script_base__ = {
  name: 'SPPosition',
  extends: StylePanelMixin,
  components: {
    StyleConfTemplate,
    WRadio
  },
  data() {
    const h = this.$createElement;
    return {
      helpText: '全局固定:相对浏览器窗口拥有固定坐标',
      positionOption: [{
        value: 'absolute',
        label: h("span", {
          "attrs": {
            "title": "absolute"
          },
          "class": "ucd-stylePanel-enumBox"
        }, ["\u6D6E\u52A8"])
      }, {
        value: 'relative',
        label: h("span", {
          "attrs": {
            "title": "relative"
          },
          "class": "ucd-stylePanel-enumBox"
        }, ["\u76F8\u5BF9"])
      }, {
        value: 'fixed',
        label: h("span", {
          "attrs": {
            "title": "fixed"
          },
          "class": "ucd-stylePanel-enumBox"
        }, ["\u56FA\u5B9A"])
      }, {
        value: 'sticky',
        label: h("span", {
          "attrs": {
            "title": "sticky"
          },
          "class": "ucd-stylePanel-enumBox"
        }, ["\u7C98\u6027"])
      }]
    };
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("StyleConfTemplate", {
    attrs: {
      name: "定位",
      inline: true,
      changed: _vm.changedFromDefault("position", "static")
    },
    on: {
      reset: function ($event) {
        return _vm.deleteStyle("position");
      }
    }
  }, [_c("div", {
    attrs: {
      slot: "tooltip"
    },
    slot: "tooltip"
  }, [_vm._v("\n    " + _vm._s(_vm.helpText) + "\n  ")]), _vm._v(" "), _c("WRadio", {
    attrs: {
      "with-solid-fill": "",
      value: _vm.style.position,
      options: _vm.positionOption
    },
    on: {
      change: function (val) {
        return _vm.changeAndDelete("position", val);
      }
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "comps/PropPanel/StylePanel/comps/position.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);